import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/apiConfig';

function VendorDropdown({ onChangeDropdown, showLabel = true, isDisabled, selectedValue, isClearable = true }) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const baseUrl = getApiBaseUrl();
        if (!baseUrl) return;
        const response = await axios.get(`${baseUrl}/ec-product/vendors`);
        if (response.status === 200 && response.data?.data) {
          const list = response.data.data || [];
          const mapped = list.map((v) => ({
            value: v.VendorId?.toString(),
            label: v.VendorName || `Vendor ${v.VendorId}`,
            raw: v,
          }));
          setOptions(mapped);
          if (selectedValue) {
            const match = mapped.find((m) => m.value === selectedValue?.toString());
            setSelectedOption(match || null);
          }
        }
      } catch (err) {
        console.error('Failed to load vendors', err);
      }
    };
    fetchVendors();
  }, [selectedValue]);

  useEffect(() => {
    if (!selectedValue) {
      setSelectedOption(null);
      return;
    }
    const match = options.find((m) => m.value === selectedValue?.toString());
    setSelectedOption(match || null);
  }, [selectedValue, options]);

  const handleChange = (option) => {
    setSelectedOption(option);
    if (onChangeDropdown) {
      onChangeDropdown(option);
    }
  };

  return (
    <div className="mb-0">
      {showLabel ? <label className="form-label">Vendor</label> : null}
      <Select
        options={options}
        value={selectedOption}
        onChange={handleChange}
        isClearable={isClearable}
        isDisabled={isDisabled}
        placeholder="Select vendor"
      />
    </div>
  );
}

export default VendorDropdown;
